module.exports = __webpack_public_path__ + "static/media/mia-terms-conditions-fr.164abaca.pdf";